// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.5 3H16.5V1H7.5V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 6V4H2V6H4.02898L4.52898 23H19.471L19.971 6H22ZM16.2431 10.6715L13.4147 13.5L16.2431 16.3284L14.8289 17.7426L12.0005 14.9142L9.17203 17.7426L7.75781 16.3284L10.5862 13.5L7.75781 10.6715L9.17203 9.25732L12.0005 12.0858L14.8289 9.25732L16.2431 10.6715Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-delete-1-filled')
export default class Delete1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'delete-1-filled',
    }
  }
}
